import { Reveal } from "./Reveal";
import { REVIEWS, PROFILE, IMAGES } from "../lib/data";
import { Star, Quote, PenLine } from "lucide-react";

export const Reviews = () => (
  <section id="reviews" className="relative border-t border-[#262626] overflow-hidden" data-testid="reviews-section">
    <div className="absolute inset-0 opacity-[0.08]">
      <img src={IMAGES.books} alt="" className="w-full h-full object-cover" />
    </div>
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-36">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <Reveal className="lg:col-span-7">
          <span className="overline">Client Reviews</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-5 text-[#F7F5F2]">
            Rated <span className="text-[#C8A24B]">{PROFILE.rating}</span> by {PROFILE.reviews} clients.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="flex items-center gap-2 lg:justify-end">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={26} fill="#C8A24B" strokeWidth={0} />
            ))}
          </div>
          <p className="text-[#8C8C8C] mt-3 lg:text-right">Verified on Google Business Profile</p>
          <div className="mt-6 lg:flex lg:justify-end">
            <a
              href={PROFILE.reviewUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="leave-google-review-button"
              className="group inline-flex items-center gap-2.5 rounded-sm bg-[#F7F5F2] text-[#0A0A0A] px-6 py-3.5 text-sm font-medium hover:bg-[#C8A24B] transition-colors duration-300"
            >
              <PenLine size={16} strokeWidth={1.9} />
              Leave us a Google review
              <span className="flex gap-0.5 ml-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={12} fill="#0A0A0A" strokeWidth={0} className="group-hover:opacity-90" />
                ))}
              </span>
            </a>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-px bg-[#262626] border border-[#262626]">
        {REVIEWS.map((r, i) => (
          <Reveal key={i} delay={(i % 2) * 0.1}>
            <div className="h-full bg-[#0A0A0A] p-8 lg:p-10 hover:bg-[#121212] transition-colors duration-500" data-testid={`review-${i}`}>
              <Quote size={28} className="text-[#C8A24B]" strokeWidth={1.25} />
              <p className="font-serif text-xl lg:text-2xl leading-snug text-[#F7F5F2] mt-6">
                “{r.quote}”
              </p>
              <div className="mt-8 flex items-center justify-between border-t border-[#262626] pt-5">
                <div>
                  <p className="text-[#F7F5F2] text-sm">{r.name}</p>
                  <p className="font-mono text-xs text-[#8C8C8C] mt-1 uppercase tracking-wider">{r.matter}</p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, j) => (
                    <Star key={j} size={13} fill="#C8A24B" strokeWidth={0} />
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={PROFILE.googleListingUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="read-all-reviews-button"
            className="inline-flex items-center gap-2 rounded-sm border border-[#F7F5F2]/25 text-[#F7F5F2] px-7 py-3.5 text-sm font-medium hover:border-[#C8A24B] hover:text-[#C8A24B] transition-colors duration-300"
          >
            Read all {PROFILE.reviews} reviews on Google
          </a>
          <a
            href={PROFILE.reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-leave-button"
            className="group inline-flex items-center gap-2 rounded-sm bg-[#F7F5F2] text-[#0A0A0A] px-7 py-3.5 text-sm font-medium hover:bg-[#C8A24B] transition-colors duration-300"
          >
            <PenLine size={16} strokeWidth={1.9} /> Leave a review
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
